export const IS_CATEGORY_HEADER_ENABLED_DEFAULT = false;
